import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3763d330"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col" }
const _hoisted_2 = { class: "flex order-status-confirm" }
const _hoisted_3 = { class: "order-table" }
const _hoisted_4 = {
  key: 1,
  style: {"word-break":"break-word"}
}
const _hoisted_5 = { class: "tag-style" }
const _hoisted_6 = { class: "flex-ter text-name-order" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  class: "flex-bwn-wrap",
  style: {"padding":"4px 0","width":"100%"}
}

import { t } from '@/plugins/i18n'
import { ref, reactive, computed, nextTick, onMounted, toRaw } from 'vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { pageDeliveryAbnormalOrder, countDeliveryAbnormalOrderCount, countAbnormalOrderCount } from '@/apis/order'
import { getJapanTime, clearForm, setStartDateTime, setEndDateTime } from '@/util/common'
import {
  confirmTypeOrderColumns,
  confirmTypeSkuColumns,
  tableConfigOrder,
  tableConfigSku,
  confirmSkuSecondColumns,
  changeReasonCodes
} from './data'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useRtfix, useSite, isMultiStore } from '@/store'
import dblclick from '@/components/BatchSearch/index'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import ProblemHandlingOrderDialog from './ProblemHandlingOrderDialog.vue'
import ProblemHandlingResultDialog from './ProblemHandlingResultDialog.vue'
import { countryCodeNameMap } from '@/common/const'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const form = reactive({
  platformOrderNo: '',
  startTime: '',
  endTime: '',
  customerOrderNo: '',
  orderName: ''
  // deliveryProcessType: 0
})

const store = useStore()
const notProcessedOrder = computed(() => store.getters.notProcessedOrder)
/** 整单-0， sku-1 */
const deliveryProcessType = ref(0)
const dataListener = async () => {
  const { data } = await countAbnormalOrderCount({})
  // totalOrderCount
  store.commit('route/notProcessedOrder', data)
  // countDeliveryAbnormalOrderCount({}).then((res) => {
  //   const { data } = res
  //   noticeCount.value = {
  //     ...data
  //   }
  // })
}

const columns = computed(() => {
  const list = deliveryProcessType.value === 0 ? confirmTypeOrderColumns : confirmTypeSkuColumns
  return list.filter((v) => isMultiStore() || !v.isMultiStore)
})
const resetForm = () => {
  clearForm(form)
  isBatchSearch.value = false
  refreshTable(true)
}

const pageData = ref({
  page: 1,
  limit: 10
})
/** 问题处理弹窗visible */
const orderVisible = ref(false)
/** 问题处理结果弹窗visible */
const resultVisible = ref(false)
/** sku问题处理拆单之后返回的编号 */
const resultData = ref(0)
/** 开-关 问题处理弹窗 */
const changeOrderVisible = (obj: { visible: boolean, isNeedWatch?: boolean, data?: any }, row?: any) => {
  const { visible, isNeedWatch = false, data = [] } = obj
  // console.log(999, deliveryProcessType.value)
  orderVisible.value = visible
  if (!row) {
    rowItem.value = {}
    return
  }
  if (isNeedWatch) {
    resultVisible.value = true
    rowItem.value = {}
    // 拷贝下
    // const _data = data?.length > 0 ? JSON.parse(JSON.stringify(data)) : []
    resultData.value = data
    return
  }
  rowItem.value = row
}
const route = useRoute()
// 消息回显
if (route.query.deliveryProcessType) {
  deliveryProcessType.value = Number(route.query.deliveryProcessType)
}
if (route.query.platformOrderNo) {
  form.platformOrderNo = route.query.platformOrderNo
}

/** 给子表格排序，有变更理由的放在前面 */
const getTableSon = (table: any) => {
  const arr = table?.toSorted((a: any, b: any) => {
    const _aChangecode = (a.changeReasonCode === 'AR_0000' || a.cancelDelivery || a.originalDistributionId === a.recommendShipConfigId) ? 0 : 1
    const _bChangecode = (b.changeReasonCode === 'AR_0000' || b.cancelDelivery || b.originalDistributionId === b.recommendShipConfigId) ? 0 : 1
    return Number(Boolean(_bChangecode)) - Number(Boolean(_aChangecode))
  })
  return arr
}
/**  */
const changeresultVisible = (val: boolean) => {
  resultVisible.value = val
}
/** 待确认-sku-若是有变更理由则展示不同样式 */
const tableRowClassName = ({ row }: { row: any }) => {
  // 如果是sku级别，且有取消发货标识
  if (deliveryProcessType.value === 1 && row.cancelDelivery) {
    return ''
  }
  //   如果建议运输方式和原运输方式一样
  if (row.originalDistributionId === row.recommendShipConfigId) {
    return ''
  }
  if (row.changeReasonCode && row.changeReasonCode !== 'AR_0000') {
    return 'style-high-light'
  }
  return ''
}
const filterData = computed(() => {
  return {
    ...form,
    deliveryProcessType: deliveryProcessType.value,
    startTime: setStartDateTime(form.startTime),
    endTime: setEndDateTime(form.endTime)
  }
})

const searchDate = computed({
  get: () => [form.startTime, form.endTime],
  set: (newVal) => { [form.startTime, form.endTime] = newVal ?? [] }
})
/** 切换二级tab */
const switchStatus = (status: number) => {
  if (deliveryProcessType.value === status) return
  deliveryProcessType.value = status
  isBatchSearch.value = false
}

const rowItem = ref({})

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  // console.log(666, deliveryProcessType.value)
  if (type) {
    pageData.value = {
      page: 1,
      limit: 10
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
expose({
  refreshTable
})

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearchConfirmType', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    deliveryProcessType: deliveryProcessType.value
  }
  refreshTable(true)
})
const router = useRouter()
const search = () => {
  // router.push(useRtfix('article', { params: { id, type: props.type } }))
  isBatchSearch.value = false
  refreshTable(true)
}


return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_table_button = _resolveComponent("table-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(useSite)())
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_badge, {
            value: _unref(notProcessedOrder)?.wholeProcessOrderCount,
            hidden: _unref(notProcessedOrder)?.wholeProcessOrderCount <= 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                class: _normalizeClass({ active: deliveryProcessType.value === 0 }),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (switchStatus(0)))
              }, _toDisplayString(_unref(t)('整单确认')), 3)
            ]),
            _: 1
          }, 8, ["value", "hidden"]),
          _createVNode(_component_el_badge, {
            value: _unref(notProcessedOrder)?.skuProcessOrderCount,
            hidden: _unref(notProcessedOrder)?.skuProcessOrderCount <=0
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                style: {"margin-left":"62px"},
                class: _normalizeClass({ active: deliveryProcessType.value === 1 }),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (switchStatus(1)))
              }, _toDisplayString(_unref(t)('按SKU确认')), 3)
            ]),
            _: 1
          }, 8, ["value", "hidden"])
        ]),
        _createVNode(_component_el_form, {
          inline: true,
          model: _unref(form)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('THE CKB订单编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).platformOrderNo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).platformOrderNo) = $event)),
                  onDblclick: _cache[3] || (_cache[3] = ($event: any) => {_unref(form).platformOrderNo = ''; _unref(dblclick)('platformOrderNoList')}),
                  placeholder: _unref(t)('双击批量搜索'),
                  style: {"width":"220px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('客户订单编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).customerOrderNo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).customerOrderNo) = $event)),
                  onDblclick: _cache[5] || (_cache[5] = ($event: any) => {_unref(form).customerOrderNo = ''; _unref(dblclick)('customerOrderNoList')}),
                  placeholder: _unref(t)('双击批量搜索'),
                  style: {"width":"220px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('下单时间')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(searchDate),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": _unref(t)('开始时间'),
                  "end-placeholder": _unref(t)('结束时间'),
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: resetForm }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            STableRef.value = _value
          },
          onDataListener: dataListener,
          key: deliveryProcessType.value,
          api: _unref(pageDeliveryAbnormalOrder),
          "page-data": pageData.value,
          "onUpdate:page-data": _cache[8] || (_cache[8] = ($event: any) => ((pageData).value = $event)),
          filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
          columns: _unref(columns),
          tableConfig: deliveryProcessType.value === 0 ? _unref(tableConfigOrder) : _unref(tableConfigSku)
        }, {
          goodsCountry: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.goodsCountry ?? _unref(COUNTRY).CN)), 1)
          ]),
          changeReason: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(changeReasonCodes)[row.changeReasonCode] ?? '-'), 1)
          ]),
          recommendDistribution: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString((row.recommendShipConfigId === '-1' ? _unref(t)('无可用运输方式') : ( row.changeReasonCode === 'AR_0000' ? '-': row.recommendDistribution )) || '-'), 1)
          ]),
          customerOrderNo: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.customerOrderNo || '-'), 1)
          ]),
          platformOrderNo: _withCtx(({ row }) => [
            _createElementVNode("div", {
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
              style: {"word-break":"break-word"}
            }, [
              (row.platformOrderId)
                ? (_openBlock(), _createBlock(AppLink, {
                    key: 0,
                    to: _unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId } })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.platformOrderNo), 1))
            ])
          ]),
          orderCreateTime: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.orderCreateTime)), 1)
          ]),
          expand: _withCtx(({ scope }) => [
            _createVNode(STable, {
              "table-data": getTableSon(scope.row.details),
              columns: _unref(confirmSkuSecondColumns),
              showPagination: false,
              tableRowClassName: tableRowClassName
            }, {
              productSkuImg: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_5, [
                  (row.cancelDelivery)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        class: "cancel-delievery-tag",
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('已取消')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, [
                    (row.productSkuImg)
                      ? (_openBlock(), _createBlock(ShoppingPreview, {
                          key: 0,
                          image: row.productSkuImg
                        }, null, 8, ["image"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(row.productTitleJp), 1)
                  ])
                ])
              ]),
              changeReason: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString((_unref(changeReasonCodes)[row.changeReasonCode] && row.originalDistributionId !== row.recommendShipConfigId) ? _unref(changeReasonCodes)[row.changeReasonCode]: '-'), 1)
              ]),
              recommendDistribution: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString((row.recommendShipConfigId === '-1' ? _unref(t)('无可用运输方式') : ( row.changeReasonCode === 'AR_0000' || row.originalDistributionId === row.recommendShipConfigId ? '-': row.recommendDistribution )) || '-'), 1)
              ]),
              _: 2
            }, 1032, ["table-data", "columns"])
          ]),
          handler: _withCtx(({ scope }) => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_table_button, {
                title: _unref(t)('问题处理'),
                onClick: ($event: any) => (changeOrderVisible({ visible: true }, scope.row))
              }, null, 8, ["title", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["api", "page-data", "filterData", "columns", "tableConfig"]),
        _createVNode(BatchSearch, { title: "ConfirmType" })
      ])
    ], 2),
    (orderVisible.value)
      ? (_openBlock(), _createBlock(ProblemHandlingOrderDialog, {
          key: deliveryProcessType.value,
          onCloseDialog: changeOrderVisible,
          title: _unref(t)('问题处理'),
          visible: orderVisible.value,
          "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((orderVisible).value = $event)),
          rowItem: rowItem.value,
          deliveryProcessType: deliveryProcessType.value,
          onRefresh: refreshTable
        }, null, 8, ["title", "visible", "rowItem", "deliveryProcessType"]))
      : _createCommentVNode("", true),
    (resultVisible.value)
      ? (_openBlock(), _createBlock(ProblemHandlingResultDialog, {
          key: 1,
          onCloseDialog: changeresultVisible,
          title: _unref(t)('提示'),
          visible: resultVisible.value,
          "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((resultVisible).value = $event)),
          rowItem: toRaw(rowItem.value),
          onRefresh: refreshTable,
          resultData: resultData.value
        }, null, 8, ["title", "visible", "rowItem", "resultData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})